import { colors } from "../Colors/colors";

// color themes
export const defaultColorTheme = colors.blue;

// screen sizes
export const screenSizes = {
  mobileScreen: 576,
  desktopScreen: 1980,
};

// prod env
export const urlPath =
  process.env.NODE_ENV === "production" ? "https://eac-iotonramp-api-dev-001.azurewebsites.net" : "";
